import React from 'react';

const DEFAULT_RIGHT_PANEL_WIDTH = 450;
const MIN_RIGHT_PANEL_WIDTH = 392;
const MAX_RIGHT_PANEL_WIDTH = 800;

/**
 * Clamps the panel width to be within the allowed min/max bounds.
 * @param {number} width - The width to clamp
 * @returns {number} The clamped width
 */
const clampPanelWidth = (width) => Math.min(
  MAX_RIGHT_PANEL_WIDTH,
  Math.max(MIN_RIGHT_PANEL_WIDTH, width),
);

// LocalStorage keys for persisting layout state
const STORAGE_KEYS = {
  RIGHT_PANEL_WIDTH: 'layout_rightPanelWidth',
  FEED_LIST_COLLAPSED: 'activityFeed_feedListCollapsed',
  CHAT_PANEL_OPEN: 'layout_chatPanelOpen',
};

const initialValues = {
  title: '',
  isDrawerOpen: false,
  toggleDrawer: () => {},
  rightPanelWidth: DEFAULT_RIGHT_PANEL_WIDTH,
  setRightPanelWidth: () => {},
  rightPanelContent: null,
  setRightPanelContent: () => {},
  isChatPanelOpen: true,
  setIsChatPanelOpen: () => {},
  hasRightPanel: false,
};

const LayoutContext = React.createContext(initialValues);

export default LayoutContext;
export {
  initialValues,
  DEFAULT_RIGHT_PANEL_WIDTH,
  MIN_RIGHT_PANEL_WIDTH,
  MAX_RIGHT_PANEL_WIDTH,
  STORAGE_KEYS,
  clampPanelWidth,
};
